import { Grid } from '@material-ui/core';
import React from 'react';
import Card from '../../components/Card/Card.component';
import { ICustomer, ICustomerReport } from '../../models/ICustomers';
import Label from '../Label/Label.component';

interface Props {
    data: ICustomerReport
}

export default function CustomerStats({
    data
}: Props) {
    return (
        <Card>
            <Grid container>
                <Grid xs={12} md={3} lg={2} item>
                    <Label bold>
                        Money spent:
                    </Label>
                </Grid>
                <Grid xs={12} md={9} lg={10} item>
                    <Label>
                        ${data?.moneySpent}
                    </Label>
                </Grid>
                <Grid xs={12} md={3} lg={2} item>
                    <Label bold>
                        Points earned:
                    </Label>
                </Grid>
                <Grid xs={12} md={9} lg={10} item>
                    <Label>
                        {data?.pointsEarned}
                    </Label>
                </Grid>
                <Grid xs={12} md={3} lg={2} item>
                    <Label bold>
                        Rewards Redeemed:
                    </Label>
                </Grid>
                <Grid xs={12} md={9} lg={10} item>
                    <Label>
                        {data?.rewardsRedeemed}
                    </Label>
                </Grid>
            </Grid>
        </Card>
    )
}
